module.exports = __webpack_public_path__ + "static/media/Muller-ExtraBold-DEMO.05be004b.ttf";